export default function getResource(label) {
    const resources = {
        items: 'Items',
        item: 'Item',
        substitution: 'Substitution Preferences'
    };

    return resources[label];
}
